module.exports = __webpack_public_path__ + "static/media/DP_Timeless_Piazza_DK Gold.75650fa0.png";